import Cookies from 'js-cookie';

const validDays: number = 90;

export const setCookie = (cookieName: string, cookieValue: string) => {
	Cookies.set(cookieName, cookieValue, { expires: validDays });
};
